import { trans } from '@spotahome/soyuz/client';

import Link from '../Link';
import openPlusValuePropositionModal from '../PlusValueProposition/PlusValuePropositionModal';

const PlusLabelDescription = () => {
  const handleOnClick = e => {
    e.preventDefault();
    openPlusValuePropositionModal();
  };

  return (
    <>
      {trans('plus.value.proposition.description')}{' '}
      <strong>
        <Link
          onClick={handleOnClick}
          data-test="plus-value-proposition-open"
          size="medium"
          theme="dark"
        >
          {trans('plus.value.proposition.see-more')}
        </Link>
      </strong>
    </>
  );
};

export default PlusLabelDescription;
